@import "../../../../globalStyles/commons";

:host {
  display: block;
}

.canvas-wrapper {
  background: var(--layer-hover-01);
}

#canvas-background circle {
  fill: var(--border-disabled);
}

#endarrow polyline{
  fill: none;
  stroke: #231F20;
  vector-effect: non-scaling-stroke;
  stroke-width: 2;
}


.line {

  &.no-color {
    stroke: var(--border-strong-01);
  }
}


.clickable {
  cursor: pointer;

  &:hover .line {

    stroke: v(--color-primary);
  }

  z-index: 1;
}
